import { autoinject } from 'aurelia-framework';
import { DialogService } from 'aurelia-dialog';
import { PLATFORM } from 'aurelia-pal';
@autoinject()
export class Home {
  constructor(
    private dialogService: DialogService
  ) {}

  public view(name: string): void {
    this.dialogService
      .open({ viewModel: PLATFORM.moduleName('components/pages/home/bio'), model: name })
      .whenClosed(response => {
      if (!response.wasCancelled) {}
    });
  }
}